import loadable from '@loadable/component'

const routers = [
  {
    path: '/demo/hiya-ui',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-scroll" */ '../pages/demo/hiya-ui'
        )
    ),
  },
  {
    path: '/demo/scroll',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-scroll" */ '../pages/demo/scroll'
        )
    ),
  },
  {
    path: '/demo/Aanimation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-Aanimation" */ '../pages/demo/Aanimation'
        )
    ),
  },
  {
    path: '/demo/Aanimation/Apng',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-Aanimation-Apng" */ '../pages/demo/Aanimation/Apng'
        )
    ),
  },
  {
    path: '',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-notFound" */ '../pages/404')
    ),
  },
]

export const getRouter = (_routers) => {
  return [..._routers, ...routers]
}
